import {useEffect, useState} from "react";
import {Link} from "wouter";

import PieChartGraph from "../charts/PieChart";
import ProfileTable from "./ProfileTable";
import {profileTips, profileTotal, successTips} from "../service/profileData";
import appConfig from "../service/config";
import {badgeDesc} from "../service/badgeDescription";
import LineChartGraph from "../charts/LineChart";
import LineChartGraphSuccess from "../charts/LineChartPercent";
import {getCookie} from "../service/cookie";

const Dashboard = ({userStats, toggleSubscription}) => {
  const [profile, setProfile] = useState([])
  const [responseMessage, setResponseMessage] = useState('')
  const token = getCookie('tk')

  useEffect(() => {
    if (userStats) {
      setResponseMessage('')
      setProfile({
        profileTips: profileTips(userStats.stats),
        successTips: successTips(userStats.stats),
        profileData: profileTotal(userStats.stats)
      })
    }
  }, [userStats])

  if(!userStats) {
    return <></>
  }

  const getBadgeIcon = badge => {
    return <td><img alt="" src={'./wp-content/uploads/badges/'+badge+'.png'} className={'img-badge badge-'+badge} /></td>;
  }

  return (
    <>
      <h3>Dashboard</h3>
      {responseMessage && <div className="text-danger">{responseMessage}</div>}
      {userStats &&
        (
          <>
            <h4>Profile data</h4>
            <table className="table table-striped">
              <tbody>
              <tr>
                <td>Name</td>
                <td>{userStats.username}</td>
              </tr>
              <tr>
                <td>Rank</td>
                <td>{userStats.tipster_level}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{userStats.email}</td>
              </tr>
              <tr>
                <td>Public profile</td>
                <td style={{wordBreak: 'break-all'}}>
                  <a href={appConfig.domain + '/tipsters/' + userStats.nicename + '/'}>
                    {appConfig.domain + '/tipsters/' + userStats.nicename + '/'}
                  </a>
                </td>
              </tr>
              <tr>
                <td> </td>
                <td><Link href={'/dashboard/reset/' + token}>Reset Password</Link></td>
              </tr>
              </tbody>
            </table>

            <h4>Badges</h4>
            <table className="table badges-table">
              <thead>
              <tr>
                <th>#</th><th>Description</th>
              </tr>
              </thead>
              <tbody>
              {userStats.stats.tipster_badges.map((badge, index) => {
                if(badge < 1) {
                  return <tr key={index} />
                }
                return (<tr key={index}>
                    {getBadgeIcon(badge)}
                    <td dangerouslySetInnerHTML={{__html: badgeDesc([index, badge])}} />
                  </tr>)
              })}
              </tbody>
            </table>

            <div className="profile-container">
              <div className="example-graph">
                <h4>Profile graph</h4>
                <PieChartGraph data={profile.profileTips}/>
              </div>
              <div className="example-graph">
                <h4>Success graph</h4>
                <PieChartGraph data={profile.successTips}/>
              </div>
            </div>
            <ProfileTable data={profile.profileData}/>
            {userStats.stats.tips_by_year.length > 0 &&
              <>
                <div className="example-graph">
                  <h4>Tips By Month</h4>
                  <LineChartGraph data={userStats.stats.tips_by_year}/>
                </div>
                <div className="example-graph">
                  <h4>Success By Month</h4>
                  <LineChartGraphSuccess data={userStats.stats.tips_by_year}/>
                </div>
              </>
            }

            <h4>Tickets stats</h4>
            <table className="table table-striped">
              <tbody>
              <tr>
                <td>Created Tickets</td>
                <td>{userStats.stats.tickets_total}</td>
              </tr>
              <tr>
                <td>Wins</td>
                <td>{userStats.stats.tickets_success_total}</td>
              </tr>
              <tr>
                <td>Winning percent</td>
                <td>
                  {userStats.stats.tickets_total < 1 ? 0 :
                  Math.round(1000 * userStats.stats.tickets_success_total / userStats.stats.tickets_total/10)}
                </td>
              </tr>
              <tr>
                <td>Earning</td>
                <td>{userStats.stats.tickets_earning_total}</td>
              </tr>
              </tbody>
            </table>
          </>
        )
      }
    </>
  )
};

export default Dashboard
